import { render, staticRenderFns } from "./form-element.vue?vue&type=template&id=0bf8a440&scoped=true&"
import script from "./form-element.vue?vue&type=script&lang=js&"
export * from "./form-element.vue?vue&type=script&lang=js&"
import style0 from "./form-element.vue?vue&type=style&index=0&id=0bf8a440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf8a440",
  null
  
)

export default component.exports